import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ChildTile from "../Common/ChildTile";
import ContentTile from "./ContentTile";
import LoadMore from "./LoadMore";
import { triggerSponsorshipAnalyticsEvent } from "../../utils/analytics-helpers.js";
import { gtmTrackEventData } from "../../utils/gtm-event-triggers";
import { childImage, donateEnvironment, noFuncProps } from "../../utils/helpers.js";
import Messaging from "../Common/Messaging";
import {
  getChildren,
  searchMethodUpdater,
  statusUpdater,
} from "wvus-sponsorship-engine";
import helpers, { getParams } from "wvus-sponsorship-engine";
import {
  getSearchDefaultParams,
  mergeSearchDefaultParams,
  getErrorMessage,
  getAppSettings,
} from "../../utils/app-settings";

class GridView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderGrid: false,
      descriptorList: [],
      tileSettings: [],
    };
  }

  componentDidMount() {
    this.props.animateGrid(true);
    this.props.setGridWasActive(true);
    const obj = this.props.lastSearchKeyObj;
    if (
      Object.keys(this.props.lastSearchKeyObj).length > 0 &&
      this.props.lastSearchKeyObj.constructor === Object
    ) {
      let foundSearch = false;
      const searchTerms = JSON.stringify(this.props.lastSearchKeyObj);
      this.setState({
        renderGrid: true,
      });
      this.props.statusUpdater("COMPLETE");
      gtmTrackEventData("spon_app_page_view", {
        "display_type": "vpv"
      });
      //no kids in redux
    } else {
      const urlParams = helpers.getParams();
      const searchDefaultParams = getSearchDefaultParams();
      const searchParams = Object.keys(searchDefaultParams).length
        ? mergeSearchDefaultParams(urlParams)
        : urlParams;

      if (
        typeof this.props.projectIdentifiers != "undefined" &&
        this.props.projectIdentifiers.length > 0
      ) {
        searchParams.projectIdentifiers = this.props.projectIdentifiers;
      }
      if (
        typeof this.props.reservePool != "undefined" &&
        this.props.reservePool != null
      ) {
        searchParams.reservationReferenceIdentifier = this.props.reservePool;
      }
      //if child is unavailable(locked) we search the grid with params
      if (
        this.props.child_unavailable.child_unavailable_search &&
        this.props.child_unavailable.child_unavailable_searchTerms.length > 0
      ) {
        const child_unavailable_terms =
          this.props.child_unavailable.child_unavailable_searchTerms;
        searchParams[child_unavailable_terms[0]] = child_unavailable_terms[1];
      }
      this.props.getChildren(this.props.take, searchParams, () => {
        if (this.props.searchMethod === "search") {
          let adpName = null;
          const searchRequest = this.props.searchRequest.children.response[0];

          if (
            Object.prototype.hasOwnProperty.call(
              this.props.searchRequest.children.request.searchCriteriaList[0],
              "projectIdentifiers"
            )
          ) {
            if (
              this.props.searchRequest.children.request.searchCriteriaList[0]
                .projectIdentifiers.length > 0 &&
              Object.keys(this.props.children).length > 0
            ) {
              adpName = this.props.children[searchRequest].projectName;
            } else {
              adpName =
                this.props.searchRequest.children.request.searchCriteriaList[0]
                  .projectIdentifiers[0];
            }

            if (
              window.wv_rcds.settings.projectDescription != "" &&
              this.props.children
            ) {
              adpName = window.wv_rcds.settings.projectDescription;
            }

            //check if adp is searched
            this.props.searchRequest.children.request.searchCriteriaList[0]
              .projectIdentifiers.length > 0
              ? this.props.setADPStatus(true, adpName)
              : "";
          }
        }
      });

      this.setState({
        renderGrid: true,
      });

      gtmTrackEventData("spon_app_page_view", {
        "display_type": "pv"
      });
    }

    const settings = getAppSettings();
    if (
      settings.tileSettings &&
      settings.tileSettings.tiles &&
      settings.tileSettings.tiles.length > 0
    ) {
      this.setState({ tileSettings: settings.tileSettings });
    } else if (
      settings.defaultTileSettings &&
      settings.defaultTileSettings.tiles.length > 0
    ) {
      this.setState({ tileSettings: settings.defaultTileSettings });
    }
  }

  classList(classList = "", property, test) {
    if (property === test) {
      return classList;
    }
    return [];
  }

  renderNoResults() {
    if (
      this.props.status == "COMPLETE" &&
      this.props.submissions.children.responseData.totalCount === 0
    ) {
      return <p>No children were found, please try again</p>;
    }
  }

  renderContentTiles(props, itemNo, tileNumber, gridVars) {
    const contentItems = props.content;
    return (
      <ContentTile
        key={itemNo}
        contentProps={contentItems[tileNumber]}
        gridVars={gridVars}
        device={this.props.device}
        status={this.props.status}
        gridVarsReceived={this.props.gridVarsReceived}
      />
    );
  }

  tileChooser(props, index, item, gridVars, itemCount) {
    // index is the index of the child tiles only, must additionally account for content tiles
    const contentTiles = this.state.tileSettings.tiles
      ? this.state.tileSettings.tiles
      : [];
    const totalContentTileCount = contentTiles.length;
    const contentTileEveryNth = this.state.tileSettings.tileSequence
      ? this.state.tileSettings.tileSequence
      : 4;
    const previouslyDisplayedContentTileCount =
      index >= contentTileEveryNth
        ? Math.floor((index - 1) / (contentTileEveryNth - 1))
        : 0;
    const contentTileIndex = previouslyDisplayedContentTileCount;

    let tilePosition = index + 1;

    if (totalContentTileCount) {
      tilePosition += previouslyDisplayedContentTileCount;
    }

    if (
      totalContentTileCount &&
      previouslyDisplayedContentTileCount < totalContentTileCount &&
      tilePosition % contentTileEveryNth === 0
    ) {
      return (
        <React.Fragment key={index}>
          <ContentTile
            key={`${index}-content-tile`}
            gridVars={gridVars}
            device={this.props.device}
            status={this.props.status}
            gridVarsReceived={this.props.gridVarsReceived}
            title={this.state.tileSettings.tiles[contentTileIndex].headline}
            image={this.state.tileSettings.tiles[contentTileIndex].image}
            image_element={this.state.tileSettings.tiles[contentTileIndex].image_element}
            content={this.state.tileSettings.tiles[contentTileIndex].body}
          />
          <ChildTile
            key={`${index}-child-tile`}
            classList={""}
            childDetail={false}
            id={index}
            {...this.props.children[item]}
            changeView={this.props.changeView}
            sponsorshipTileCtaText={`Learn more about ${this.props.children[item].givenName}`}
            gridVars={gridVars}
            handleHistory={this.props.handleHistory}
            descriptorsReceived={this.props.descriptorsReceived}
            descriptorIndex={this.props.descriptorIndexArray[index]}
            gridVarsReceived={this.props.gridVarsReceived}
            urlLink=""
            gridView={true}
            lastSearchKeyObj={this.props.lastSearchKeyObj}
          />
        </React.Fragment>
      );
    } else {
      return (
        <ChildTile
          key={index}
          classList={""}
          childDetail={false}
          id={index}
          {...this.props.children[item]}
          changeView={this.props.changeView}
          sponsorshipTileCtaText={`Learn more about ${this.props.children[item].givenName}`}
          gridVars={gridVars}
          handleHistory={this.props.handleHistory}
          descriptorsReceived={this.props.descriptorsReceived}
          descriptorIndex={this.props.descriptorIndexArray[index]}
          gridVarsReceived={this.props.gridVarsReceived}
          urlLink=""
          gridView={true}
          lastSearchKeyObj={this.props.lastSearchKeyObj}
        />
      );
    }
  }

  renderGrid(props, method, itemCount, gridVars) {
    if (method === "random") {
      const childItems = props.storedChildIds.randomSearch;
      if (childItems) {
        return childItems.slice(0, itemCount).map((item, index) => {
          return this.tileChooser(this.props, index, item, gridVars, itemCount);
        });
      }
    } else if (method === "search") {
      const searchQuery = JSON.stringify(
        this.props.searchRequest.children.request.searchCriteriaList[0]
      );
      const childItems = this.props.storedChildIds[searchQuery];
      if (childItems) {
        return childItems.slice(0, itemCount).map((item, index) => {
          return this.tileChooser(this.props, index, item, gridVars, itemCount);
        });
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.searchMethod === "search" &&
      this.props.lastSearchKeyUpdated !== true
    ) {
      this.props.updatelastSearchKeyStatus(true, () => {
        this.props.lastSearchKey(
          this.props.submissions.children.request.searchCriteriaList[0],
          () => {
            let curratedValue = null;
            if (this.props.tabSelected === "curated") {
              this.props.lastSearchKeyObj.curatedSearch =
                this.props.curatedSearchSelected;
            }

            // This Analytics Stays
            gtmTrackEventData("spon_app_child_grid_view", {
              "event_action": "sponsorship_child_grid_view",
              "search_params": this.props.lastSearchKeyObj,
              "search_props": noFuncProps(this.props),
            });

            // TODO: Remove Legacy Analytics
            triggerSponsorshipAnalyticsEvent("search.sponsorship", {
              searchParams: JSON.stringify(this.props.lastSearchKeyObj),
            });
          }
        );
      });
    }

    if (
      this.state.renderGrid === true &&
      this.props.status === "COMPLETE" &&
      !this.props.gridVarsReceived
    ) {
      this.props.calculateGrid(this.childrenGrid);
      this.props.animateGrid(false);
    }
  }
  handleDeepLinkError(props) {
    if (this.props.showDeepLinkError) {
      // console.log(...props);
      return (
        <div className="container">
          <Messaging {...props} />
        </div>
      );
    }
  }
  handleADPSearch() {
    if (
      this.props.submissions.children.request.searchCriteriaList[0]
        .projectIdentifiers.length > 0
    ) {
      // TODO: Missing something
    }
  }

  render() {
    if (this.props.status == "COMPLETE") {
      return (
        <React.Fragment>
          {this.handleDeepLinkError(this.props.message)}
          <div className="container grid-container">
            <section className={this.props.loading_class}>
              <div
                className="wvus-grid children-grid"
                ref={(el) => (this.childrenGrid = el)}
              >
                {this.renderGrid(
                  this.props,
                  this.props.searchMethod,
                  this.props.itemsToShow,
                  this.props.gridVars
                )}
              </div>
            </section>
            <LoadMore
              title="show more children"
              showMore={this.props.showMore}
              showLoadMore={this.props.showLoadMore}
              resetGridCalc={this.props.resetGridCalc}
            />
          </div>
        </React.Fragment>
      );
    } else if (this.props.status == "ERROR") {
      return (
        <div className="container">
          <p>{getErrorMessage()}</p>
        </div>
      );
    } else {
      return (
        <div className="spinner--wv-star">
          <div className="double-bounce1" />
          <div className="double-bounce2" />
        </div>
      );
    }
  }
}
// Get apps state and pass it as props to UserList
//      > whenever state changes, the UserList will automatically re-render
function mapStateToProps(state) {
  // console.log("map state to props", state);
  return {
    ...state,
    searchRequest: state.submissions,
  };
}

// Get actions and pass them as props to to UserList
//      > now UserList has this.props.selectUser
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getChildren: getChildren,
      searchMethodUpdater: searchMethodUpdater,
      // getChildById: getChildById,
      // getChildStoryById: getChildStoryById,
      statusUpdater: statusUpdater,
    },
    dispatch
  );
}

export default connect(mapStateToProps, matchDispatchToProps)(GridView);
